import { render, staticRenderFns } from "./Offset.vue?vue&type=template&id=5f6e4c54&"
import script from "./Offset.vue?vue&type=script&lang=js&"
export * from "./Offset.vue?vue&type=script&lang=js&"
import style0 from "./Offset.vue?vue&type=style&index=0&id=5f6e4c54&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/administrator/staffpanel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6e4c54')) {
      api.createRecord('5f6e4c54', component.options)
    } else {
      api.reload('5f6e4c54', component.options)
    }
    module.hot.accept("./Offset.vue?vue&type=template&id=5f6e4c54&", function () {
      api.rerender('5f6e4c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/helper/Offset.vue"
export default component.exports